import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
var AES256 = require('aes-everywhere');
@Injectable({
  providedIn: 'root'
})
export class CommonRequestService {
  private downloadTimer: any;
  private timeLeft: number = 60;
  private countDownSubject = new BehaviorSubject<number>(this.timeLeft);
  
  // Observable that can be subscribed to get the timer updates
  countDown$ = this.countDownSubject.asObservable();
  constructor(private router: Router) { }

    //Implement for dencrypt local stroga data
    public decryptService(data, toJson) {
      try {
  
        const value = localStorage.getItem(data);
        const decryptValue = value ? AES256.decrypt(value, environment.AESKey) : value;
        return toJson ? JSON.parse(decryptValue) : decryptValue;
      } catch (e) {
        if (e.message == 'Error parsing salt' || e.message == 'Malformed UTF-8 data') {
          setTimeout(() => {
            this.router.navigate(['/']);
            localStorage.clear();
            console.clear
          }, 1000)
        }
      }
    }
  
    //Implement for encrypt local stroga data
    public encryptService(key, value) {
      value = typeof value === 'object' ? JSON.stringify(value) : value;
      let encrypt = AES256.encrypt(value, environment.AESKey);
      return localStorage.setItem(key, encrypt);
  
    }
      //Implement for jarvis param encrypt
      encryptJarvisRequest(data) {
        if (data != null) {
            const user = JSON.stringify(data);
            const encryptKey = environment.jarvisEncyKey;
            return  AES256.encrypt(user, encryptKey);
        }
    }
      //Implement for encrypt data to send payload
      setJarvisParam(data) {
          return this.encryptJarvisRequest(data)
      }

          //Implement commom method for select next and previous
    keytab(event: any, fieldType: any) {
      let nextInput = event.srcElement.nextElementSibling; // get the sibling element
      let prevInput = event.srcElement.previousSibling;
      const target = event.target || event.srcElement;
      const maxl = target.maxLength;
          if (event.code === 'Backspace' && event.target.value === '' && fieldType != 'First') {
          // Focus on the previous field
          prevInput.focus();
          prevInput.select();
          }
      
          if (nextInput == null || maxl > target.value.length || fieldType == 'Last') {  // check the maxLength from here
          return;
          } else {
          nextInput.focus();
          nextInput.select();
          }   
    }
    //Implement common method for paste otp
    pasteOTP(event: ClipboardEvent, form: FormGroup, formControlPrefix: any, index: number): void {
      event.preventDefault();
      const clipboardData = event.clipboardData;
      if (clipboardData) {
        const pastedText = clipboardData.getData('text').trim().substring(0, 6); // Get only the first 6 characters from the pasted text
        const numericText = pastedText.replace(/\D/g, ''); // Remove non-numeric characters
        const inputFields = document.querySelectorAll(`input[formControlName^="${formControlPrefix}"]`); // Select input fields dynamically based on formControlPrefix
        for (let i = 0; i < numericText.length && index + i < inputFields.length; i++) {
          const controlName = `${formControlPrefix}${index + i + 1}`;
          const digitControl = form.get(controlName);
          if (digitControl) {
            digitControl.setValue(numericText[i]);
            if (index + i + 1 < inputFields.length) {
              (inputFields[index + i + 1] as HTMLElement).focus();
            }
          }
        }
      }
    }

    //Implement for OTP resend count down
    startCountdown(initialTime: number = 60) {
      this.timeLeft = initialTime;
      this.stopCountdown(); // Clear any existing timer
      this.downloadTimer = setInterval(() => {
        if (this.timeLeft <= 0) {
          this.stopCountdown();
        } else {
          this.countDownSubject.next(this.timeLeft);
        }
        this.timeLeft -= 1;
      }, 1000);
    }
  
    stopCountdown() {
      if (this.downloadTimer) {
        clearInterval(this.downloadTimer);
      }
      this.countDownSubject.next(0);
    }
}
